import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FieldTypes } from '../../FieldTypes';
import { GlobalsService } from '../../services/globals.service';
import { ViasConnectionService } from '../../services/vias-connection.service';
import { FormItem, FormOption, ServiceCall } from '../form/FormItem';

@Component({
  selector: 'vias-edit-dialog',
  templateUrl: './edit-dialog.component.html',
  styleUrls: ['./edit-dialog.component.scss']
})
export class EditDialogComponent {
  numLocale: string;
  pageName: string = '';
  hasSubmitButton: boolean = true;
  submitBtnText: string = 'save';
  pageGeneralData: {}[];
  formData: any;
  formItems: FormItem[] = [];
  formRefx;
  @ViewChild('formDialog', { static: false }) set formRef(formDialog: ElementRef | null) {
    if (!formDialog) { return; }
    this.afterFormInit(formDialog);
  }
  constructor(
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected translate: TranslateService,
    public dialogRef: MatDialogRef<EditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.numLocale = this.globals.numLocale;
    if (data.pageName !== undefined) {
      this.pageName = data.pageName;
    }
    if (data.hasSubmitButton !== undefined) {
      this.hasSubmitButton = data.hasSubmitButton;
    }
    if (data.submitBtnText !== undefined) {
      this.submitBtnText = data.submitBtnText;
    }
    if (data.formItems !== undefined) {
      this.formItems = data.formItems;
    }
    if (data.parentRef !== undefined) {
      if (data.parentRef.pageGeneralData !== undefined) {
        this.pageGeneralData = data.parentRef.pageGeneralData;
      }
    }
    if (data.pageGeneralData !== undefined) {
      this.pageGeneralData = data.parentRef.pageGeneralData;
    }
    if (data.row !== undefined) {
      this.formData = data.row;
    }
    this.submitBtnText = globals.getTranslate(this.submitBtnText);
    this.formItems.forEach(e => {
      if (this.pageGeneralData !== undefined) {
        if (e.optionsFieldName !== undefined) {
          if (this.pageGeneralData[e.optionsFieldName] !== undefined) {
            e.options = [];
            this.pageGeneralData[e.optionsFieldName].forEach(data => {
              const lbl = data[e.optionsDataLabelField !== undefined ? e.optionsDataLabelField : 'name'];
              e.options.push({
                label: this.globals.getTranslate(lbl),
                data: data[e.optionsDataIdField !== undefined ? e.optionsDataIdField : 'id'].toString()
              });
            });
          }
        }
      }
      if (this.formData !== undefined) {
        if (this.formData[e.name] !== undefined) {
          if (e.type === FieldTypes.DatePicker) {
            e.value = this.formData[e.name] * 1 === 0 ? null : new Date(this.formData[e.name] * 1000);
          } else if (e.type === FieldTypes.CheckBox) {
            e.value = Number(this.formData[e.name]);
          } else {
            e.value = this.formData[e.name];
          }
        }
      }
      if (e.options !== undefined) {
        e.options.forEach(eo => {
          eo.label = this.globals.getTranslate(eo.label);
        });
      }
      this.translate.get(e.label).subscribe((translated: string) => {
        e.label = translated;
      });
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit(formData): void {
    this.dialogRef.close({ formData });
  }
  formItemClickHandler($event: FormItem): void {
    if ($event.iconClick !== undefined) {
      $event.iconClick(this,
        this.globals, this.viasService, this.translate
      );
    }
  }
  afterFormInit(form): void {
    // formRef init olunca set ediliyor, yokdsa null
    this.formRefx = form;
    form.formChange.subscribe(changed => {
      // item bul
      const item: FormItem = this.formItems.find(e => e.name === changed.itemName);
      if (item.onChangedServiceCall !== undefined) {
        const csca: ServiceCall[] = item.onChangedServiceCall;
        csca.forEach(csc => {
          let data: object = {};
          data[csc.data] = changed.val;
          if (csc.initData !== undefined) {
            data = {
              ...data,
              ...csc.initData
            };
          }
          if (csc.isContractor === undefined) {
            csc.isContractor = false;
          }
          let serviceUrl = csc.isContractor === true ? this.globals.contractorServerURL : this.globals.serverURL;
          this.viasService.send(
            csc.pid,
            csc.aid,
            data,
            serviceUrl
          )
            .then(r => {
              console.log(r);
              if (r.error) {
                this.globals.handleErrors(r.error);
              }
              if (r.data !== undefined) {
                if (r.data[csc.returnField] !== undefined) {
                  // baska alana deger olarak gir
                  // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                  // tslint:disable-next-line: triple-equals
                  if (csc.otherFieldVal !== undefined) {
                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                    // baska alana data source
                  } else if (csc.otherFieldDataSource !== undefined) {
                    const fItem: FormItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                    const res = r.data[csc.returnField];
                    const opt: FormOption[] = [];
                    for (const s in res) {
                      if (s !== undefined) {
                        opt.push({
                          label: res[s][fItem.optionsDataLabelField],
                          data: res[s][fItem.optionsDataIdField]
                        });
                      }
                    }
                    fItem.options = opt;
                  }
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
      // onchange fonk varsa calistir
      if (item.onChangedFunc !== undefined) {
        console.log(item.onChangedFunc);
        item.onChangedFunc(changed.val, this);
      }
    });
    //set value
    this.formItems.forEach(item => {
      if (this.formRefx.form.controls[item.name] !== undefined) {
        if (item.type === 'checkbox') {
          this.formRefx.form.controls[item.name].setValue(item.value * 1);
        } else if (item.type === 'datepicker') {
          const d: Date = new Date(item.value * 1000);
          this.formRefx.form.controls[item.name].setValue(d);
        } else {
          this.formRefx.form.controls[item.name].setValue(item.value);
        }
      }
    });
  }
}
